//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MenuQuickItem',
  props: ['path', 'icon', 'exact', 'action', 'open_externally'],
  data() {
    return {}
  },
  computed: {
    tag() {
      return 'a'
    }
  },
  mounted() {},
  methods: {
    invokeMethod(methodName) {
      eval("this."+methodName+""); 
    },
    isExternal(url) {
      if(_.isString(url))
        return url.match(/^https?:\/\//i)
      return false;
    },
    openGlobalIframe() {
      this.loadGlobalIframe('open_page', {'url': '/help'})
    },
  }
}
